import React from "react";
import { Box, Typography } from "@mui/material";
import { OcCurrency } from "oc/components";

interface MyCafeteriaCostsBoxProps {
  label: string;
  currencyValue: number;
  isMobile: boolean;
}

export const MyCafeteriaCostsBox: React.FC<MyCafeteriaCostsBoxProps> = ({
  label,
  currencyValue,
  isMobile,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      width={isMobile ? "auto" : "258px"}
      padding="16px"
      borderRadius="8px"
      border="1px solid #C6CACC"
    >
      <Typography variant="body1" style={{ color: "#919699" }}>
        {label}
      </Typography>
      <Typography variant="body1" style={{ color: "#5E6366" }}>
        {OcCurrency({ value: currencyValue })}
      </Typography>
    </Box>
  );
};

export default MyCafeteriaCostsBox;
